<div>
  <app-entity-listing
    [totalCount]="totalRowsCount"
    [state]="sectionState"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [emptyStateMainLabel]="'Users.EmptyStateMainLabel' | translate"
    [emptyStateSubLabel]="'Users.EmptyStateSubLabel' | translate"
    [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
    (pageIndexChange)="onPageIndexChange($event)"
  >
    <div [hidden]="!dataSource">
      <div class="filter-controls-wrapper flex align-center mb-4">
        <app-search-input
          [placeholder]="'Placeholder.DottedSearch' | translate"
          class="search flex"
          (searchValue)="onSearch($event)"
        ></app-search-input>

        <div class="status">
          <mat-form-field appearance="outline" class="flex flex-start">
            <p matPrefix class="status-prefix">{{ "Users.StatusPrefix" | translate }}</p>

            <mat-select (selectionChange)="onSelectStatus($event.value)" [value]="userStatus.All">
              <mat-option *ngFor="let status of userStatus | enumToArray" [value]="status.value">
                {{ "Enum.UserStatus." + status.key | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="table-container">
        <table class="table scrollable scrollable--y scrollable--x" mat-table [dataSource]="dataSource" matSort matSortDirection="asc">
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef class="code-col-width">{{ "Users.Table.GeneratedCode" | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.code }}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="col-width">{{ "Users.Table.Name" | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <div class="media-container flex row">
                <div class="img-container" *ngIf="false">
                  <img
                    class="img"
                    [src]="
                          element.img_path
                            ? element.img_path
                            : 'assets/images/shipment-control-icon.svg'
                        "
                  />
                </div>
                <div class="text-container">{{ element.name }}</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef class="col-width">{{ "Users.Table.Email" | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.email || "_____" }}</td>
          </ng-container>

          <ng-container matColumnDef="mobileNumber">
            <th mat-header-cell *matHeaderCellDef class="col-width">{{ "Users.Table.MobileNumber" | translate }}</th>
            <td mat-cell *matCellDef="let element" [class.rtl]="layoutService.websiteDirection$.value === 'rtl'">{{ element.mobileNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="roles">
            <th mat-header-cell *matHeaderCellDef class="roles-width">{{ "Users.Table.Privilege" | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngFor="let role of element.roles; let i = index">
                <div *ngIf="i < 3" class="role">
                  <div class="roles-limited-text">{{ 'Enum.Roles.' + role.name | translate}}</div>

                  <div *ngIf="i == 2 && element.roles.length - 3 > 0" class="roles-count">+ {{ element.roles.length - 3 }}</div>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef [hidden]="true"></th>
            <td mat-cell *matCellDef="let element" [hidden]="true">{{ element.updatedAt }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="col-width">{{ "Users.Table.Status" | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <app-status-label [value]="element.status"></app-status-label>
            </td>
          </ng-container>

          <ng-container matColumnDef="shippingType">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="col-width"
              [hidden]="((RolesConstants.CUSTOMER_ADD_EDIT_USER | userRoleChecker) && userType === UserType.FLEET) || !(RolesConstants.CUSTOMER_ADD_EDIT_USER | userRoleChecker)"
            >
              {{ "Inputs.ShippingType" | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              [hidden]="((RolesConstants.CUSTOMER_ADD_EDIT_USER | userRoleChecker) && userType === UserType.FLEET) || !(RolesConstants.CUSTOMER_ADD_EDIT_USER | userRoleChecker)"
            >
              {{ ("Enum.ShippingType." + element.shippingType | translate) || "_____" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th class="center" mat-header-cell *matHeaderCellDef></th>

            <td class="center action" app-click-stop-propagation mat-cell *matCellDef="let element">
              <div class="flex justify-center align-center" *ngIf="!(RolesConstants.FLEET_USER_USERS | userRoleChecker)">
                <div class="flex justify-center" [matMenuTriggerFor]="menu">
                  <span ><app-icon name="menu-vert"  class="cursor-pointer text-700"></app-icon>
                  </span>
                </div>

                <mat-menu class="item-actions" #menu>
                  <!-- view action -->
                  <mat-option (click)="showDetails.emit(element.id)">
                    <span>{{ "Buttons.Details" | translate }}</span>
                  </mat-option>

                  <!-- assign admin -->
                  <!--
                      <mat-option>
                        <span>
                          {{ "Buttons.AssignGlobalAdmin" | translate }}
                        </span>
                      </mat-option> -->

                  <!-- resend invitation -->
                  <!-- <mat-option *ngIf="!element.isEmailVerified">
                        <span>
                          {{ "Buttons.ResendInvitation" | translate }}
                        </span>
                      </mat-option> -->

                  <!-- reset password -->
                  <!-- <mat-option *ngIf="element.status === userStatus.ACTIVE" (click)="onResetPasswordOptionClicked(element)">
                        <span>
                          {{ "Buttons.ResetPassword" | translate }}
                        </span>
                  </mat-option> -->

                  <!-- activate action -->
                  <!-- <mat-option
                        *ngIf="element.status !== userStatus.ACTIVE"
                        (click)="onChangeUserStatus(element.id, true)"
                      >
                        <span>
                          {{ "Buttons.Activate" | translate }}
                        </span>
                      </mat-option> -->

                  <!-- deactivate action -->
                  <!-- <mat-option
                        *ngIf="element.status === userStatus.ACTIVE"
                        (click)="onChangeUserStatus(element.id, false)"
                      >
                        <span>
                          {{ "Buttons.Deactivate" | translate }}
                        </span>
                      </mat-option> -->

                  <!-- delete action -->
                  <!-- <mat-option (click)="onDeleteUserClicked(element.id)">
                        <span class="delete">
                          {{ "Buttons.Delete" | translate }}
                        </span>
                      </mat-option> -->
                </mat-menu>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="showDetails.emit(row.id)"></tr>
        </table>
      </div>
    </div>
  </app-entity-listing>
</div>
